import * as React from "react";
import type { Dispatch } from "redux";
import { connect } from "react-redux";
import type { ReduxState, ActionTypes } from "../reducers/reducers";
import { ReportLogic } from "../reducers/logic/businessLogic";

const POLL_INTERVAL_MS = 60_000;

type OwnProps = {};
type Props = OwnProps & ReduxProps;

class CurrentDowntimes extends React.Component<Props> {
    // here we store the timer for regular update of current downtimes
    timer?: ReturnType<typeof setInterval>;

    componentDidMount() {
        this.timer = setInterval(() => {
            this.loadCurrentStatuses();
        }, POLL_INTERVAL_MS);
    }

    componentDidUpdate = (prev_props: Props) => {
        // if no report yet, do nothing
        if (this.props.report_data === null) {
            return;
        }
        // check if anything changed
        if (
            this.props.report_uuid !== prev_props.report_uuid ||
            this.props.line_group_uuid !== prev_props.line_group_uuid
        ) {
            this.loadCurrentStatuses();
        }
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    loadCurrentStatuses = () => {
        // make sure we have something to load
        if (this.props.report_data === null) {
            return;
        }
        // we do, refresh
        ReportLogic.getLineStatuses(this.props.report_data, this.props.line_group_uuid, this.props.reduxDispatch);
    };

    render() {
        return <></>;
    }
}

const mapState = (state: ReduxState) => {
    const report_uuid = state.gantt_chart_report.original_report_uuid;
    const report_data = state.gantt_chart_report.report_data;
    return {
        report_uuid,
        report_data,
        line_group_uuid: state.gantt_chart_properties.line_group_uuid,
    };
};

const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
const ConnectedCurrentDowntimes = connect<
    ReturnType<typeof mapState>,
    ReturnType<typeof mapDispatch>,
    OwnProps,
    ReduxState
>(
    mapState,
    mapDispatch
)(CurrentDowntimes);

export default ConnectedCurrentDowntimes;
